/**
 * Tracks: the subject a drill belongs to.
 *
 * A track is what you enrol in, and the scheduler only ever serves drills from
 * tracks you are enrolled in. This exists so the bank can hold subjects that
 * have nothing to do with each other (TypeScript today, SQL later) without one
 * of them polluting the other's schedule. Someone practising SQL should never
 * be handed a debounce problem because it happened to be due.
 *
 * Ids are stored per user in the database, so they must not change once used.
 */
export type TrackId = "typescript" | "sql";

export type Track = {
  id: TrackId;
  name: string;
  /** Shown on the enrolment control and the problems page. */
  blurb: string;
  /** False for a track with no problems yet: listed, but not selectable. */
  available: boolean;
};

export const TRACKS: Track[] = [
  {
    id: "typescript",
    name: "TypeScript",
    blurb:
      "The utilities a senior screen actually asks for: timers, event plumbing, async orchestration, caches and structural comparison.",
    available: true,
  },
  {
    id: "sql",
    name: "SQL",
    blurb: "Queries and schema problems. Nothing in it yet.",
    available: false,
  },
];

/** Everyone starts here, including accounts that predate tracks existing. */
export const DEFAULT_TRACKS: TrackId[] = ["typescript"];

export const trackById = (id: string): Track | undefined =>
  TRACKS.find((t) => t.id === id);
